document.addEventListener("DOMContentLoaded", function () {
  const quizPopup = document.getElementById("quizPopup");
  const quizStartButton = document.getElementById("quizStartButton");
  const quizExitButton = document.getElementById("quizExitButton");

  if (!sessionStorage.getItem("quizPopupClosed")) {
      quizPopup.classList.add("show");
      document.body.classList.add("no-scroll"); 

  }
  if (quizStartButton) {
        quizStartButton.addEventListener("click", function () {
            const quizLink = quizStartButton.getAttribute("data-quiz-link");
            if (quizLink && quizLink.trim() !== "") {
                window.location.href = quizLink;
            }
        });
    }
  if (quizExitButton) {
      quizExitButton.addEventListener("click", function () {
          quizPopup.classList.remove("show");
          document.body.classList.remove("no-scroll"); 
          sessionStorage.setItem("quizPopupClosed", "true");
      });
  }
});
